<template>
    <div id="ToursTab" class="wrap">
        <loading
            :active.sync="isLoading"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="fullPage"
        ></loading>
        <div class="line-item toolbar">
            <div class="left-item">
                <div class="search open-search">
                    <md-icon class="search-glass-icon">search</md-icon>
                    <div class="search-field">
                        <div class="md-input-focused md-input-container">
                            <input v-model="filterString" type="text" class="md-input"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-item tour-buttons">
                <span v-if="showTourButtons">
                    <div class="el">
                        <md-button class="md-icon-button" @click="openDialog()">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </div>
                    <div class="el" v-if="checkedIncomCom === 0 || currentClient.compIncomStatus === 1">
                        <md-button v-if="exportRunning" class="export-button " @click="selectedToursExport"> <span>EXPORT</span>  </md-button>
                        <md-button v-else class="export-button" @click="selectedToursExport">    <span>EXPORT</span></md-button>
                    </div>
                    <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
                        <div class="md-dialog-container" tabindex="-1">
                            <span data-v-ec680dbc="" class="md-dialog-title md-title">
                                You have requested an export of  <b data-v-ec680dbc="">
                                <span
                                    v-for="(item, i) in exportModalName "
                                    :key="i">
                                    <span v-if="i>0">{{ ', ' }}</span>
                                    <span class="text-nowrap">{{ item }}</span>
                                </span>
                                </b>- we will notify you via email when it is ready.
                            </span>
                            <div data-v-ec680dbc="" class="md-dialog-content">
                                <b data-v-ec680dbc="">Client Name :</b>
                                {{ currentClientName }}
                            </div>
                            <div data-v-ec680dbc="" class="md-dialog-content">
                            <b data-v-ec680dbc="">Description :</b>
                            <span
                                v-for="(item, i) in exportModalName "
                                :key="i">
                                <span v-if="i>0">{{ ', ' }}</span>
                                    <span class="text-nowrap">{{ item }}</span>
                                </span>
                            </div>
                            <md-dialog-actions class="full-btn">
                                <md-button class="ManualBtn ManualBtncancel" @click="closeDialog_export()">Ok</md-button>
                            </md-dialog-actions>
                        </div>
                    </md-dialog>
                    <div id="bs-modal" v-if="showModal_tours">
                    <!-- MODAL -->
                    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title" id="myModalLabel">Export Details</h4>
                                </div>
                                <div class="modal-body">
                                    You have requested for following Tours:
                                    <h3>Demo</h3>
                                    <h3>Dave</h3>
                                    <h3>Info</h3>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-default" data-dismiss="modal" @click="notShowModal">Close</button>
                                    <button type="button" class="btn btn-primary">Save changes</button>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </span>
                <div class="el spinner-container">
                    <md-progress-spinner v-if="exportRunning" class="md-accent export-running-spinner" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
                </div>
            </div>
        </div>
        <div class="row selectable" v-if="showdatalist">
            <div class="tour-card-wrap" v-for="(tour, index) in tours" :key="tour.id" v-if="filterCheck(tour.name)">
                <TourCard :tour="tour" :index="index"></TourCard>
            </div>
        </div>
        <div v-else>
            Loading records.
        </div>
        <div class="bottom-btn-position">
            <div class="wrap">
                <md-button @click="createNewTour" class="add-tour-button md-fab md-accent md-primary">
                    <md-icon>add</md-icon>
                </md-button>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                This will delete the tour, all of its routes, topics, triggers, and analytics data.
                <div class="scroll-cont-wrap">
                    <md-list>
                        <md-list-item v-for="index in checked" :key="index" class="line-item">
                            <div class="el">{{ tours[index].name }}</div>
                        </md-list-item>
                    </md-list>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="deleteTour">DELETE</md-button>
                <button class="ManualBtn ManualBtncancel extraClass" @click="closeDialog">CANCEL</button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="copyTourStatusAlert">
            <md-dialog-title>
                Important Information
            </md-dialog-title>
            <md-dialog-content>
            You have requested to copy a tour we will notify you via email when it is ready.
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtncancel" @click="copyTourStatusAlert = false">Ok</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import TourCard from './TourCard';
import {copyTourToNewTours, changeToursImagesServices} from '../../services/ToursService';
import {EventBus} from './event-bus.js';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data () {
    return {
      showDialog: false,
      showDeleteDialog: false,
      filterString: '',
      showModal_tours: false,
      exportModalClientId: '',
      exportModalTourIds: '',
      exportModalName: '',
      showdatalist: false,
      isShow: false,
      isLoading: false,
      copyTourStatusAlert: false
    };
  },
  computed: {
    ...mapGetters('tours', ['tours', 'exportRunning', 'checked', 'checkComIncompA', 'redCount']),
    ...mapGetters('client', ['currentClient']),
    ...mapGetters('client', ['currentClientName', 'currentClient', 'clientLoaded']),
    showTourButtons () {
      return this.checked.length > 0;
    },
    checkedIncomCom () {
      return this.redCount;
    },
    filterStringIsEmpty () {
      return this.filterString.replace(/^\s+|\s+$/g, '').length === 0;
    }
  },
  methods: {
    ...mapActions('tours', ['loadClientToursList', 'exportTours', 'emptyChecked', 'closeExportModal', 'deleteTours', 'emptyCheckedRedGreen']),
    openDialog () {
      this.showDialog = true;
    },
    closeDialog () {
      this.showDialog = false;
    },
    closeDialog_export () {
      this.showDeleteDialog = false;
      this.emptyChecked();
    },
    deleteTour () {
      let tourIds = [];
      if (this.checked.length > 0) { // Checks that at least one tour is selected
        for (let tourIndex of this.checked) {
          tourIds.push(this.tours[tourIndex].id);
        }
        this.deleteTours({clientId: this.currentClient.id, tourIds: tourIds});
        this.emptyChecked();
        this.showDialog = false;
      }
    },
    createNewTour () {
      const tour = {
        card: '',
        city: '',
        clientId: this.$store.state.client.currentClient.id,
        defaultActivate: 'Proximity',
        defaultDelay: '0',
        defaultRadiusDistance: '40',
        defaultTolerance: '60',
        description: '',
        id: '',
        name: '',
        systemId: '1'
      };

      this.$store.dispatch('tours/loadNewTour', tour);
      this.$store.dispatch('topics/setTopicsList', []);
      this.closeExportModal();
      this.$router.push('/tour/new');
    },
    filterCheck (text) {
      let passesFilter = true;
      if (text && text.replace(/^\s+|\s+$/g, '').length > 0 && !this.filterStringIsEmpty) {
        passesFilter = (text.toLowerCase()).includes(this.filterString.toLowerCase());
      }
      return passesFilter;
    },
    async selectedToursExport () {
      // Creates and builds an array of tour IDs using the selected indexes from the tours tab
      let tourIds = [];
      let tourName = [];
      if (this.checked.length > 0) { // Checks that at least one tour is selected
        for (let tourIndex of this.checked) {
          tourIds.push(this.tours[tourIndex].id);
          tourName.push(this.tours[tourIndex].name);
        }
        this.exportModalClientId = this.currentClient.id;
        this.exportModalTourIds = tourIds;
        this.exportModalName = tourName;
        this.exportTours({tourIds: tourIds, clientId: this.currentClient.id});
        this.openModal();
      }
    },
    openModal () {
      this.showDeleteDialog = true;
      this.isShow = true;
    },
    notShowModal () {
      this.isShow = false;
    },
    copyAtoursAndCreateNewTour (tourId) {
      let varCopytour = this;
      // this.isLoading = true;
      copyTourToNewTours(tourId).then(function (responce) {
        varCopytour.loadClientToursList(varCopytour.currentClient.id);
        varCopytour.showdatalist = true;
        varCopytour.emptyChecked();
        varCopytour.emptyCheckedRedGreen();
        varCopytour.isLoading = false;
        if (responce.status === 200) {
          varCopytour.copyTourStatusAlert = true;
        }
      });
    },
    changeToursImagesParent (filesDetails, tourId) {
      let varCopytour = this;
      this.isLoading = true;
      changeToursImagesServices(filesDetails, tourId).then(function (responce) {
        let pp = varCopytour;
        varCopytour.loadClientToursList(varCopytour.currentClient.id).then(function (responce) {
          pp.emptyChecked();
          pp.isLoading = false;
        });
      });
    }
  },
  mounted () {
    let pp = this;
    this.isLoading = true;
    this.loadClientToursList(this.currentClient.id).then(function (responce) {
      pp.showdatalist = true;
      pp.emptyChecked();
      pp.emptyCheckedRedGreen();
      pp.isLoading = false;
    });
    EventBus.$on('openDialogForSingle', ($params) => {
      if ($params === 'delete') {
        this.openDialog();
      } else if ($params === 'export') {
        this.selectedToursExport();
      }
    });
  },
  components: {
    TourCard: TourCard,
    template: '#bs-modal',
    Loading
  }
};
</script>

<style scoped type="scss">
.md-dialog-actions.full-btn .ManualBtncancel .md-ripple {
    display: contents !important;
}

#ToursTab .search .search-glass-icon {
    position: absolute !important;
}

.ManualBtn .md-ripple {
    display: contents !important;
}

#ToursTab .md-icon {
    height: 36px !important;
    font-size: 24px !important;
}

#ToursTab .search {
    margin-top: 8px !important;
}

.md-input {
    width: 100% !important;
    padding-right: 36px !important;
}

#ToursTab .search .md-button.md-icon-button {
    left: 0px !important;
    top: 0px !important;
}

#ToursTab .search input {
    width: 360px;
    font-size: 100%;
}

#ToursTab .export-button {
    margin: 14px 0 14px 8px;
    color: rgba(255, 255, 255, 0.87);
    background-color: rgb(0, 168, 202);
}

#ToursTab .export-running-spinner {
    margin: 14px 0 14px 8px;
}

#ToursTab .disabled-button {
    background-color: #DBDBDB;
}

#ToursTab .spinner-container {
    width: 50px;
}

.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;
    z-index: 9;
}

.scroll-cont-wrap {
    max-height: 200px !important;
    overflow: auto !important;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
    margin: 0 8px;
    float: left;
    width: 19%;
    padding: 8px !important;
}

#forCss .md-ripple {
    display: contents !important;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

@media only screen and (max-width: 1024px) {
    .tour-card-wrap div.md-card.tour-card div.md-card-media {
        max-width: 100% !important;
    }

    .tour-card-wrap div.md-card.tour-card {
        max-width: 100%;
    }

}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/ToursTab.vue